const menus = {
  slide: require('./menus/slide').default
};

export default menus;
